// extracted by mini-css-extract-plugin
module.exports = {"container":"e_oq","buttonPrev":"e_pq","buttonNext":"e_qq","hidden":"e_rq","iconPrev":"e_sq","iconNext":"e_tq","scrollView":"e_uq","card":"e_vq","scroller":"e_wq"};